/*
 * @Author: bbqin
 * @Date: 2022-12-07 10:01:16
 * @LastEditTime: 2023-03-27 13:33:34
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\api\cryptograph\adapter\sm.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import { toast } from '../../toast';

import { loadJS } from '../../../../core';

const componentNameSpace = 'CASM2Client';

const loadSMJS = function (success, error) {
    if (window[componentNameSpace]) {
        return;
    }
    const src = '../../../../cryptograph/algorithm/sm/index.js';
    // 加载js
    loadJS(
        src,
        () => {
            try {
                let component = window[componentNameSpace].default;
                console.log(component);
                success && success();
            } catch (e) {
                console.log(e);
                error && error();
            }
        },
        () => {
            console.error(`找不到${src}这个文件，请检查引用路径资源`);
            error && error();
        }
    );
};

/**
 * 国密算法smx
 */
class SMX {
    constructor(props) {
        this.cipher = {};
        this.check();
    }

    // 检查组件是否完成初始化，主要针对国密场景
    check(callback) {
        let CASM2Client = window[componentNameSpace]?.default || window[componentNameSpace];

        if (typeof CASM2Client === 'undefined') {
            this.cipher = {};
            loadSMJS(
                () => {
                    let CASM2Client = window[componentNameSpace]?.default || window[componentNameSpace];
                    this.cipher = new CASM2Client();
                    callback && callback();
                },
                () => {
                    throw new Error('未找到国密算法的库');
                }
            );
        } else {
            try {
                this.cipher = new CASM2Client();
                callback && callback();
            } catch (error) {
                console.error(error);
            }
        }
    }

    // 捕获异常并且提示
    catchToToast(callback) {
        let result;
        try {
            result = callback();
        } catch (error) {
            console.error(error);
            try {
                toast({ color: 'danger', content: error.message, mark: 'sm-error-toast' });
            } catch (error) {
                console.error(error);
            }
        }
        return result;
    }

    /**
     * 对称加密
     * @param {string} message
     * @param {string} key
     * @returns  {string}
     */
    symmetricEncrypt(message = '', key) {
        // TODO 可以做一些异常参数的判断
        let result = this.catchToToast(() => this.cipher?.symmetEncryptData(key, message));
        return result;
    }

    /**
     * 对称解密
     * @param {string} message
     * @param {string} key
     * @returns  {string}
     */
    symmetricDecrypt(message = '', key) {
        // TODO 可以做一些异常参数的判断
        let result = this.catchToToast(() => this.cipher?.symmetDecryptData(key, message));
        return result;
    }

    /**
     * 生成密钥
     * @returns {JSON}
     */
    generateKey() {
        // {"keyIndex":"-1","secretKey":"VKKuc6o1GFyszmhbsQg2fQ=="}
        // TODO 可以做下生成key格式的校验
        let result = this.catchToToast(() => this.cipher?.symmetGenerateKey());

        return result;
    }

    /**
     * 获取存储的密钥
     * @returns {string}
     */
    getSecretKey() {
        const result = this.catchToToast(() => this.cipher?.getSecretKey());
        return result;
    }

    /**
     * 非对称加密
     * @param {string} message
     * @param {string} key
     * @returns {string}
     */
    asymmetricEncrypt(message, key) {
        // TODO 可以做一些异常参数的判断
        let result = this.catchToToast(() => this.cipher?.asymmetEncryptData(message, key));

        return result;
    }

    /**
     * 非对称解密
     * @param {string} message
     * @returns {string}
     */
    asymmetricDecrypt(message, key) {
        // TODO 可以做一些异常参数的判断
        let result = this.catchToToast(() => this.cipher?.asymmetDecryptData(message, key));
        return result;
    }

    /**
     * 生成公钥
     * @returns {string}
     */
    generatePublicKey() {
        let result = this.catchToToast(() => this.cipher?.asymmetGetPublicKey());
        return result;
    }

    /**
     * 获取公钥
     * @returns {string}
     */
    getPublicKey() {
        return '';
    }

    // 加签
    sign(salt, data) {
        let result = this.catchToToast(() => this.cipher?.signet(salt, data));

        return result;
    }
}

SMX.loadSMJS = loadSMJS;

export default SMX;
